import { render, staticRenderFns } from "./Change-password.vue?vue&type=template&id=01578a6f&"
import script from "./Change-password.vue?vue&type=script&lang=js&"
export * from "./Change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports